import React from "react";
import "../App.css";
import "./styles/schedule.css";
import cloud1 from "../images/cloud1.svg";
import cloud2 from "../images/cloud2.svg";
import frog from "../images/frog.png";
import bearTBD from "../images/bear-tbd.png";
import { forwardRef } from "react";

function Schedule(props, ref) {
  return (
    <>
      <div
        ref={ref}
        class="schedule position-relative text-white text-center w-100 display-block"
      >
        <div class="content" style={{ top: "3vw" }}>
          <h1 style={{ fontSize: "4vw", fontWeight: "bold" }}>SCHEDULE</h1>
          {/* <div className="p-5">
            <p>Schedule Coming Soon!</p>
            <img src={bearTBD} alt="Hopper Image" style={{ maxWidth: "40%" }} />
          </div> */}
          <div class="frog-friend text-center">
            <img
              src={frog}
              class="img-fluid"
              alt="Hopper Image"
              style={{ maxWidth: "20%" }}
            />
          </div>
          <h1>Bootcamp Week</h1>
          <div className="w-75 m-auto">
            <div class="container-fluid py-5">
              <div class="row">
                <div class="col-lg-12">
                  <div class="horizontal-timeline">
                    <ul class="list-inline items">
                      <li class="list-inline-item items-list">
                        <div class="px-4">
                          <div class="event-date badge position-relative">
                            <img
                              className="position-absolute"
                              src={cloud1}
                              style={{
                                left: -15,
                                top: -90,
                                width: "100px",
                                height: "100px",
                              }}
                              alt="Cloud"
                            />
                            <span
                              className="position-absolute text-black"
                              style={{
                                left: 10,
                                top: -50,
                              }}
                            >
                              Jan 29 <br />
                              6-7pm
                            </span>
                          </div>
                          <h5 class="pt-2">
                            ChatGPT Workshop <br />
                            SAC 306
                          </h5>
                          <p class="text-white">
                            A sneak peek into what to expect for the event Learn
                            how to use the OpenAI API and how to integrate it
                            into your personal ...
                          </p>
                          <div>
                            <div>
                              <button
                                type="button"
                                class="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#event1"
                              >
                                Read more
                              </button>
                              <div
                                class="modal fade text-black"
                                id="event1"
                                tabindex="-1"
                                role="dialog"
                              >
                                <div
                                  class="modal-dialog modal-dialog-centered"
                                  role="document"
                                >
                                  <div class="modal-content">
                                    <div class="modal-header">
                                      <h5
                                        class="modal-title"
                                        id="event1ModalLabel"
                                      >
                                        ChatGPT Workshop
                                      </h5>
                                    </div>
                                    <div class="modal-body">
                                      A sneak peek into what to expect for the
                                      event Learn how to use the OpenAI API and
                                      how to integrate it into your personal
                                      projects using Python! Learn about prompt
                                      engineering and how to make requests to
                                      the API.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-inline-item items-list">
                        <div class="px-4">
                          <div class="event-date badge position-relative">
                            <img
                              className="position-absolute"
                              src={cloud1}
                              style={{
                                left: -15,
                                top: -90,
                                width: "100px",
                                height: "100px",
                              }}
                              alt="Cloud"
                            />
                            <span
                              className="position-absolute text-black"
                              style={{
                                left: 10,
                                top: -50,
                              }}
                            >
                              Jan 30 <br />
                              6-7pm
                            </span>
                          </div>
                          <h5 class="pt-2">
                            Intro to Hardware <br /> SAC 306
                          </h5>
                          <p class="text-white">
                            Arduino 101 basic fundamentals of both hardware and
                            software. Arduino is the best way for one to get ...
                          </p>
                          <div>
                            <button
                              type="button"
                              class="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#event2"
                            >
                              Read more
                            </button>
                            <div
                              class="modal fade text-black"
                              id="event2"
                              tabindex="-1"
                              role="dialog"
                            >
                              <div
                                class="modal-dialog modal-dialog-centered"
                                role="document"
                              >
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5
                                      class="modal-title"
                                      id="event2ModalLabel"
                                    >
                                      Intro to Hardware w/ Motor Sports
                                    </h5>
                                  </div>
                                  <div class="modal-body">
                                    Arduino 101 basic fundamentals of both
                                    hardware and software. Arduino is the best
                                    way for one to get into both hardware and
                                    software. Many projects prototype uses
                                    Arduino as base and expands outward from
                                    there due to its accessibility and easy
                                    understanding. By the end of the workshop,
                                    the main goal is to pass on the interest and
                                    knowledge of a small tinkering project for
                                    one to work on. Will be going over the
                                    layout of the Arduino Software coding
                                    portion. The general area on where
                                    pre-examples are made already and how to
                                    start it. Lastly, the hardware portion and
                                    how to do electrical wiring.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-inline-item items-list">
                        <div class="px-4">
                          <div class="event-date badge position-relative">
                            <img
                              className="position-absolute"
                              src={cloud1}
                              style={{
                                left: -15,
                                top: -90,
                                width: "100px",
                                height: "100px",
                              }}
                              alt="Cloud"
                            />
                            <span
                              className="position-absolute text-black"
                              style={{
                                left: 10,
                                top: -50,
                              }}
                            >
                              Feb 1 <br />
                              6-7pm
                            </span>
                          </div>
                          <h5 class="pt-2">
                            Intro to 3D Modeling <br />
                            SAC 305
                          </h5>
                          <p class="text-white">
                            We will create a 3D model of Hopper using Spline,
                            which is a realtime, web-based 3D design tool that
                            is easy to use. The ...
                          </p>
                          <div>
                            <button
                              type="button"
                              class="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#event3"
                            >
                              Read more
                            </button>
                            <div
                              class="modal fade text-black"
                              id="event3"
                              tabindex="-1"
                              role="dialog"
                            >
                              <div
                                class="modal-dialog modal-dialog-centered"
                                role="document"
                              >
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5
                                      class="modal-title"
                                      id="event3ModalLabel"
                                    >
                                      Intro to 3D Modeling
                                    </h5>
                                  </div>
                                  <div class="modal-body">
                                    We will create a 3D model of Hopper using
                                    Spline, which is a realtime, web-based 3D
                                    design tool that is easy to use. The final
                                    product will be an interactive website with
                                    3D Hopper, which can be further customized
                                    to your own liking!
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-inline-item items-list">
                        <div class="px-4">
                          <div class="event-date badge position-relative">
                            <img
                              className="position-absolute"
                              src={cloud1}
                              style={{
                                left: -15,
                                top: -90,
                                width: "100px",
                                height: "100px",
                              }}
                              alt="Cloud"
                            />
                            <span
                              className="position-absolute text-black"
                              style={{
                                left: 10,
                                top: -50,
                              }}
                            >
                              Feb 2 <br />
                              6-7pm
                            </span>
                          </div>
                          <h5 class="pt-2">
                            Intro to Web Dev <br /> SAC 311
                          </h5>
                          <p class="text-white">
                            Join us in replicating the LinkedIn Login Page with
                            basic html and css! Scan QR Code for a raffle prize
                            at the end!
                          </p>
                          <div>
                            <button
                              type="button"
                              class="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#event4"
                            >
                              Read more
                            </button>
                            <div
                              class="modal fade text-black"
                              id="event4"
                              tabindex="-1"
                              role="dialog"
                            >
                              <div
                                class="modal-dialog modal-dialog-centered"
                                role="document"
                              >
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5
                                      class="modal-title"
                                      id="event4ModalLabel"
                                    >
                                      Intro to Web Development w/ Web Dev Club
                                    </h5>
                                  </div>
                                  <div class="modal-body">
                                    Join us in replicating the LinkedIn Login
                                    Page with basic html and css! Scan QR Code
                                    for a raffle prize at the end!
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container p-5">
            <div class="row">
              <div class="col-lg-4 col-md-12 mb-3 w-50" id="Saturday, Feb 14th">
                <h4 class="mt-0 mb-3 op-8 font-weight-bold fs-2">
                  Saturday, Feb 3rd
                </h4>
                <ul class="list-timeline list-timeline-primary fs-5">
                  {/* Check in */}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">11AM - 11:30AM</span> -
                      Check in
                    </p>
                  </li>

                  {/* Opening Ceromony */}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">11:30AM - 12PM</span> -
                      Opening Ceromony
                    </p>
                  </li>

                  {/* Team Building Activity */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-1"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8 ">12PM - 1PM</span> -{" "}
                      <span class="fw-bold"> Team Building Activity</span>
                    </p>
                    <p
                      class="collapse my-0 flex-fw text-xs op-8 text-white"
                      id="day-1-item-1"
                    >
                      <span class="text-white">Virtual</span>{" "}
                    </p>
                  </li>

                  {/* UI/UX Workshop */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-4"
                  >
                    <p class="my-0flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">12:30PM - 1:30PM</span> -
                      <span class="fw-bold"> UI/UX Workshop</span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8 text-white"
                      id="day-1-item-4"
                    >
                      <span class="text-white">Virtual</span>{" "}
                    </p>
                  </li>

                  {/* Lunch*/}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">2PM - 3PM</span> - Lunch
                    </p>
                  </li>

                  {/* Team Photo Raffle & Hopper Drawing Contest */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-6"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">2PM - 3PM</span> -{" "}
                      <span class="fw-bold">
                        {" "}
                        Team Photo Raffle & Hopper Drawing Contest{" "}
                      </span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8"
                      id="day-1-item-6"
                    >
                      <span class="text-white">TBD</span>{" "}
                    </p>
                  </li>

                  {/* Airclay Workshop */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-7"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">3PM - 4PM</span> -
                      <span class="fw-bold">
                        {" "}
                        Airclay Workshop
                      </span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8"
                      id="day-1-item-7"
                    >
                      <span class="text-white">deVries Center Room 109-111, 121 - 123</span>{" "}
                    </p>
                  </li>

                  {/* Intro to ML Workshop */}
                  <li
                    class="list-timeline-item p-0 pb-3 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-8"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">4PM - 5PM</span> -
                      <span class="fw-bold"> Intro to ML Workshop </span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8"
                      id="day-1-item-8"
                    >
                      <span class="text-white">deVries Center Room 109-111 + Google Meet</span>{" "}
                    </p>
                  </li>

                  {/* Cryptography workshop */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-10"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">6PM - 7PM</span> -
                      <span class="fw-bold"> Cryptography workshop </span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8"
                      id="day-1-item-10"
                    >
                      <span class="text-white">deVries Center Room 109-111 + Google Meet</span>{" "}
                    </p>
                  </li>

                  {/* Dinner */}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">7PM - 8PM</span> - Dinner
                    </p>
                  </li>

                  {/* Minecraft TNT Launcher Competition */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-12"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">8PM - 9PM</span> -
                      <span class="fw-bold">
                        {" "}
                        Minecraft TNT Launcher Competition
                      </span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8"
                      id="day-1-item-12"
                    >
                      <span class="text-white">deVries Center Room 121-123 + Google Meet</span>{" "}
                    </p>
                  </li>

                  {/* Movie Night */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-13"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">7PM - 9PM</span> -
                      <span className="fw-bold"> Movie Night</span>
                    </p>
                    <p
                      class="my-0 collapse flex-fw text-uppercase text-xs op-8"
                      id="day-1-item-13"
                    >
                      <span class="text-white">TBD</span>{" "}
                    </p>
                  </li>

                  {/* In-person compnent ends */}
                  <li class="list-timeline-item p-0 pb-3 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">10:30</span> - In-person
                      ends
                    </p>
                  </li>
                </ul>
              </div>

              <div class="col-lg-4 col-md-12 mb-3 w-50" id="Sunday, Feb 15th">
                <h4 class="mt-0 mb-3 op-8 font-weight-bold fs-2">
                  Sunday, Feb 4th
                </h4>
                <ul class="list-timeline list-timeline-primary fs-5">
                  {/* Hacking ends */}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">12PM</span> - Hacking ends / Project Submission Deadline
                    </p>
                  </li>

                  {/* Judging */}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">2PM - 5:00PM</span> -
                      Judging
                    </p>
                  </li>

                  {/* Trivia Game */}
                  <li
                    class="list-timeline-item hover-effect p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column"
                    data-bs-toggle="collapse"
                    href="#day-1-item-1"
                  >
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8 ">3PM - 4PM</span> -{" "}
                      <span class="fw-bold"> Trivia Game</span>
                    </p>
                    <p
                      class="collapse my-0 flex-fw text-xs op-8 text-white"
                      id="day-1-item-1"
                    >
                      <span class="text-white">Virtual</span>{" "}
                    </p>
                  </li>

                  {/* Closing Ceremony */}
                  <li class="list-timeline-item p-0 pb-3 pb-lg-4 d-flex flex-wrap flex-column">
                    <p class="my-0 flex-fw text-sm text-uppercase">
                      <span class="text-inverse op-8">6PM - 7PM</span> - Closing
                      Ceremony
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="clouds">
            <img
              src={cloud1}
              alt="Cloud Image"
              className="position-absolute cloud-animation-1"
              style={{
                maxWidth: "15%",
                top: 400,
                right: 0,
                zIndex: -1,
                opacity: 0.2,
              }}
            />
            <img
              src={cloud2}
              alt="Cloud Image"
              className="position-absolute img-fluid cloud-animation-3"
              style={{
                maxWidth: "15%",
                top: 137,
                left: -10,
                zIndex: -1,
                opacity: 0.5,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default forwardRef(Schedule);
